// Every map in the SPA must initialize the Google loader with identical
// options. The loader is a singleton and rejects later calls that reuse its
// id with a different libraries list.
export const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: 'fnh-google-maps',
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
  libraries: ['geometry'],
};

export const GOOGLE_MAPS_API_KEY = GOOGLE_MAPS_LOADER_OPTIONS.googleMapsApiKey;
